import { useState } from 'react';
import { Radio } from '@iwoca/orion';
import styles from './BankStatements.module.css';
import TrueLayerLink from './TrueLayer/TrueLayerLink';
import { getQueryParameter, getWindowLocation } from '@iwRouter/LocationHelper';
import ManualUpload from './ManualUpload';
import { FormattedMessage } from 'react-intl';
import messages from './BankStatements.messages';
import { TStatus } from '../../NewDocUploads.types';
import Required from '../../DocumentRequirement/Required';
import Completed from '../../DocumentRequirement/Completed';
import { tracking } from '@iwoca/frontend-tracking-library';
import { isMobileWidth } from '../../../../../../iwMedia/BreakpointHelper';

const BankStatements = ({
    quantifier,
    status,
    showStatus
}: {
    quantifier: number;
    status: TStatus;
    showStatus: boolean;
}) => {
    const getInitialResolutionMethod = () => {
        const location = getWindowLocation();
        const referer = getQueryParameter(location, 'referer');

        if ((referer && referer === 'truelayer_callback') || isMobileWidth()) {
            return 'truelayer';
        }

        return 'manual';
    };

    const [resolutionMethod, setResolutionMethod] = useState(
        getInitialResolutionMethod
    );

    const resolutionMethodsData = [
        { header: 'Link my bank account', value: 'truelayer' },
        { header: 'Add business bank statements', value: 'manual' }
    ];

    const renderResolutionMethods = () => {
        switch (resolutionMethod) {
            case 'manual':
                return <ManualUpload />;
            case 'truelayer':
                return (
                    <TrueLayerLink
                        toggleManualUpload={() => setResolutionMethod('manual')}
                    />
                );
        }
    };

    return (
        <>
            <div className={styles.headerSection}>
                <div className={styles.title}>
                    <h4 data-testid="bank-statements">
                        <FormattedMessage
                            {...messages.title}
                            values={{
                                strongText: (
                                    <strong>Business bank statements</strong>
                                ),
                                duration:
                                    quantifier > 1
                                        ? `${quantifier} months`
                                        : '1 month'
                            }}
                        />
                    </h4>
                    {showStatus &&
                        (status === 'required' || status === 'error') && (
                            <Required />
                        )}
                    {(status === 'pending' || status === 'completed') && (
                        <Completed />
                    )}
                </div>
                <h5 className={styles.subTitle}>
                    <FormattedMessage {...messages.subtitle} />
                </h5>
            </div>
            <div className={styles.options}>
                {resolutionMethodsData.map(({ value, header }) => (
                    <div className={styles.radioSection} key={value}>
                        <Radio
                            label={header}
                            onChange={() => {
                                setResolutionMethod(value);

                                if (value === 'truelayer') {
                                    tracking.ampli.newDocUploadsClickedLinkBankAccountSection();
                                } else {
                                    tracking.ampli.newDocUploadsClickedManualBankStatementSection();
                                }
                            }}
                            checked={resolutionMethod === value}
                            frame
                        />
                    </div>
                ))}
            </div>
            {renderResolutionMethods()}
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default BankStatements;
